var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEyeClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 39,
    height: 39,
    rx: 1.5,
    stroke: "#C6C2C1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.0325 14.4275C12.74 14.135 12.74 13.6625 13.0325 13.37C13.325 13.0775 13.805 13.0775 14.0975 13.37L26.33 25.6175C26.6225 25.91 26.6225 26.3825 26.33 26.675C26.0375 26.9675 25.565 26.9675 25.2725 26.675L23.2325 24.635C22.2275 25.025 21.14 25.25 20 25.25C16.25 25.25 13.0475 22.9175 11.75 19.625C12.3275 18.1475 13.295 16.8725 14.51 15.905L13.0325 14.4275ZM23.75 19.625C23.75 17.555 22.07 15.875 20 15.875C19.6175 15.875 19.25 15.95 18.8975 16.055L17.27 14.4275C18.1325 14.15 19.0475 14 20 14C23.75 14 26.9525 16.3325 28.25 19.6175C27.7325 20.9375 26.9075 22.0925 25.865 23.015L23.57 20.72C23.675 20.375 23.75 20.0075 23.75 19.625ZM20 23.375C17.93 23.375 16.25 21.695 16.25 19.625C16.25 19.0475 16.385 18.5 16.6175 18.02L17.795 19.1975C17.7725 19.3325 17.75 19.475 17.75 19.625C17.75 20.87 18.755 21.875 20 21.875C20.15 21.875 20.285 21.8525 20.4275 21.8225L21.605 23C21.1175 23.24 20.5775 23.375 20 23.375ZM22.2275 19.3775C22.115 18.3275 21.29 17.51 20.2475 17.3975L22.2275 19.3775Z",
    fill: "#565656"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeClose);
export default __webpack_public_path__ + "static/media/eye_close.647dcd632ffa13b076dd2baceda8d822.svg";
export { ForwardRef as ReactComponent };